import { Avatar } from '@mui/material'
import { Card, CardContent, Typography } from '@mui/material'
import { translations } from '../../translations';

interface ProfileHeaderProps {
  name: string
  email: string
  phone: string
  joinDate: string
  location: string
  avatarUrl: string
  isRtl: boolean
}

export function ProfileHeader({ 
  name,
  email,
  phone,
  joinDate, 
  location, 
  avatarUrl,
  isRtl,
}: ProfileHeaderProps) {
  const t = isRtl ? translations.ku : translations.en;
  const formattedDate = new Date(joinDate).toLocaleDateString('en-GB')
  
  return (
    <Card elevation={0} dir={isRtl ? 'rtl' : 'ltr'}>
      <CardContent>
          <div style={{ display: 'flex', gap: '24px', flexDirection: 'column', alignItems: 'flex-start'}}>
            <Avatar
              src={avatarUrl}
              alt={name}
              sx={{ width: 192, height: 192, borderRadius: 2 }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <Typography variant="h4" component="h1" gutterBottom>
                  {name}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', gap: 1 }}>
                  {t.joined} {formattedDate}
                  <span>•</span>
                  <span style={{ fontWeight: 500 }}>{location}</span>
                </Typography>
              </div>
              <div>
                <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', gap: 1 }}>
                  <a href={`mailto:${email}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                    {email}
                  </a>
                  <span>•</span>
                  <a href={`tel:${phone}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                    <span style={{ fontWeight: 500 }}>{phone}</span>
                  </a>
                </Typography>
              </div>
            </div>
          </div>
      </CardContent>
    </Card>
  )
}

